import { render, staticRenderFns } from "./ContatoList.vue?vue&type=template&id=60487900&scoped=true"
import script from "./ContatoList.vue?vue&type=script&lang=js"
export * from "./ContatoList.vue?vue&type=script&lang=js"
import style0 from "./ContatoList.vue?vue&type=style&index=0&id=60487900&prod&scoped=true&lang=css"
import style1 from "./ContatoList.vue?vue&type=style&index=1&id=60487900&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60487900",
  null
  
)

export default component.exports